export default __webpack_public_path__ + "static/media/QR.add28128.PNG";